var screen = {
    mobile: '@media screen and (max-width: 768px)',
    tablet: '@media screen and (min-width: 769px)',
    desktop: '@media screen and (min-width: 1216px)',
    large: '@media screen and (min-width: 1408px)',
    xLarge: '@media screen and (min-width: 1921px)',
};
var fontSize = {
    mini: '',
    small: '',
    default: '',
    medium: '',
    large: ''
};
export var ThemeBuilder = function (_a) {
    var vars = _a.vars;
    return ({
        page: { bg: '#E9EDF0', txt: '#5d5e5f' },
        block: { bg: '#fff', txt: '#000' },
        accent: { bg: '#2140ff', txt: '#edf1f4' },
        accent2nd: { bg: '#2140ff', txt: '#edf1f4' },
        accent3rd: { bg: '#2140ff', txt: '#edf1f4' },
        brand: { bg: '#2140ff', txt: '#edf1f4' },
        button: { bg: '#fff', txt: '#000' },
        cta: { bg: '#2140ff', txt: '#edf1f4' },
        error: { bg: '#cb0a16', txt: '#ffffff' },
        success: { bg: '#42cf36', txt: '#000' },
        info: { bg: '#2a303c', txt: '#fcfcfc' },
        vars: vars,
        boxShadow: {
            default: "0 1px 2px 0 rgba(148, 172, 186, .3), 0 1px 3px 1px rgba(148, 172, 186, .15)",
            dark: "0 1px 2px 0 rgba(148, 172, 186, .3), 0 1px 3px 1px rgba(148, 172, 186, .15)",
            hover: '0 0 0px rgba(0, 0, 0, .14), 0 4px 8px rgba(0, 0, 0, .28)',
            bottom: "0px 15px 10px -15px rgba(0, 0, 0, .28)",
        },
        fontSize: fontSize,
        fontFamily: '\'Montserrat\', sans-serif',
    });
};
